import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import { red } from '@material-ui/core/colors';
import ShareIcon from '@material-ui/icons/Share';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Fade from 'react-reveal/Fade';
import moment from 'moment';
import axios from 'axios';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 500,
    borderRadius: 15,
    marginBottom: 20,
    boxShadow: '5px 5px 5px #aaa'
    
  },
  media: {
    borderRadius: 15
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  deleteIcon:{
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

export default function MemeCard(props) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [caption, setCaption] = React.useState(props.data.caption);
  const [url, setUrl] = React.useState(props.data.url);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const updateMeme = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    axios({
      url: apiUrl + `memes/${props.data.id}`,
      method: 'PATCH',
      data: {
        url, caption
      }
    }).then((res, err)=>{
      if(err) throw err;
      console.log(res.data);
      props.getMemes();
      handleClose();
    }).catch(err=>{
      console.log("err=>", err);
    });
  }



  return (
    <Fade bottom>
      <div>
          <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">{"Update Meme Post"}</DialogTitle>
          <DialogContent>
                  <div className="container">
                      <div className="row text-white">
                        <div className="">
                          <div className="justify-content-center">
                              <div className="form-group">
                                  <br />
                                  <input type="text" value={props.data.name} className="form-control" placeholder="Name" disabled />
                              </div>
                              <div className="form-group">
                                  <br />
                                  <input type="text" value={props.data.category} className="form-control" placeholder="Caption" disabled />
                              </div>
                              <div className="form-group">
                                  <br />
                                  <input onChange={(e)=>setCaption(e.target.value)} value={caption} type="text" className="form-control" placeholder="Caption" required />
                              </div>
                              <div className="form-group">
                                  <br />
                                  <input onChange={(e)=>setUrl(e.target.value)} value={url} type="text" className="form-control" placeholder="Url" required />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={updateMeme} color="primary">
              Update
            </Button>
          </DialogActions>
        </Dialog>
          <Card className={classes.root} >
          <CardHeader
              avatar={
              <Avatar aria-label="recipe" className={classes.avatar}>
                  {props.data.name[0].toUpperCase()}
              </Avatar>
              }
              action={
              <IconButton onClick={handleClickOpen} aria-label="settings">
                  <EditIcon/>
              </IconButton>
              }
              
              title={`${String(props.data.name).toUpperCase()}`}
          />
            <img
              className={classes.media}
              src={props.data.url}
              style={{height: '312px', width: '360px'}}
              alt="Paella dish"
          />
          <CardContent>
              <div variant="body2" color="textSecondary" component="p">
                <h6>{props.data.caption}</h6>
              </div>
          </CardContent>
          <CardActions disableSpacing>
              <i style={{paddingLeft: 5}}>
              {moment(props.data.updatedAt).startOf().fromNow()}
              </i>
              <div className={classes.deleteIcon}>
                <IconButton className={classes.deleteIcon}>
                <ShareIcon/>
                </IconButton>
                <IconButton onClick={()=>props.deletePost(props.data.id)} className={classes.deleteIcon}>
                <DeleteIcon/>
                </IconButton>
              </div>
          </CardActions>
          </Card>
      </div>
    </Fade>
  );
}
